var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4859_58518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2.35294V29.6471C32 30.2711 31.7521 30.8696 31.3108 31.3108C30.8696 31.7521 30.2711 32 29.6471 32H2.35294C1.7289 32 1.13042 31.7521 0.689161 31.3108C0.247898 30.8696 0 30.2711 0 29.6471L0 2.35294C0 1.7289 0.247898 1.13042 0.689161 0.689161C1.13042 0.247898 1.7289 0 2.35294 0L29.6471 0C30.2711 0 30.8696 0.247898 31.3108 0.689161C31.7521 1.13042 32 1.7289 32 2.35294ZM9.41177 12.2353H4.70588V27.2941H9.41177V12.2353ZM9.83529 7.05882C9.83777 6.70286 9.77012 6.3499 9.63618 6.02008C9.50225 5.69027 9.30467 5.39007 9.05471 5.13662C8.80476 4.88316 8.50733 4.68143 8.1794 4.54293C7.85148 4.40443 7.49949 4.33187 7.14353 4.32941H7.05882C6.33494 4.32941 5.6407 4.61697 5.12884 5.12884C4.61697 5.6407 4.32941 6.33494 4.32941 7.05882C4.32941 7.78271 4.61697 8.47694 5.12884 8.98881C5.6407 9.50067 6.33494 9.78823 7.05882 9.78823C7.41481 9.79699 7.76903 9.73552 8.10125 9.60733C8.43348 9.47915 8.73718 9.28675 8.99502 9.04115C9.25286 8.79554 9.45978 8.50154 9.60396 8.17594C9.74814 7.85034 9.82675 7.49952 9.83529 7.14353V7.05882ZM27.2941 18.1459C27.2941 13.6188 24.4141 11.8588 21.5529 11.8588C20.6161 11.8119 19.6834 12.0114 18.8478 12.4375C18.0121 12.8636 17.3028 13.5013 16.7906 14.2871H16.6588V12.2353H12.2353V27.2941H16.9412V19.2847C16.8732 18.4644 17.1315 17.6504 17.6602 17.0195C18.1889 16.3886 18.9452 15.9918 19.7647 15.9153H19.9435C21.44 15.9153 22.5506 16.8565 22.5506 19.2282V27.2941H27.2565L27.2941 18.1459Z",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4859_58518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.61e09e719372dd8eea902fbfbd7b4e20.svg";
export { ForwardRef as ReactComponent };